import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Modal,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { PlayArrow, MoreVert } from '@mui/icons-material';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import clone from 'packages/novous_web/src/assets/icons/Clone.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import map from 'packages/novous_web/src/assets/icons/Map Stroke.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import add from 'packages/novous_web/src/assets/icons/add.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import comment from 'packages/novous_web/src/assets/icons/Comment.svg';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import AlertToast from '../../../../../../common/components/Alert';
import LiveFeedModal from '../../../../Reports/components/LiveFeed';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import InputField from 'packages/novous_web/src/common/components/InputField';
import link from 'packages/novous_web/src/assets/icons/Link.svg';

interface Alert {
  id: string;
  driverName: string;
  vehicleNumber: string;
  device_id: string;
  vehicleId: string;
  alertDate: string;
  vehicleName: string;
  warningSortKey: string;
  videoUrl: string[];
  warningType: string;
  warningString: string;
  driverId: string;
}

interface AlertsGridProps {
  alertState: any;
}

const dateTimeStyles = {
  fontFamily: '"Inter Tight", sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0%',
  color: '#767676',
};

const AlertsGrid: React.FC<AlertsGridProps> = ({ alertState }) => {
  const heading = 'Share Footage';
  const subheading = 'Enter an email address to share this Footage';
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, tripId: '', vehicleId: '' });
  const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
  const [driverDialogOpen, setDriverDialogOpen] = useState<any>();

  const {
    data: DriverCoachingVideosData,
    error: DriverCoachingVideosError,
    loading: DriverCoachingVideosLoading,
    fetchData: DriverCoachingVideosRequestData,
  } = useAxios<any>(API_ENDPOINTS.coaching.DRIVER_COACHING_VIDEOS, 'POST');

  useEffect(() => {
    DriverCoachingVideosRequestData({
      driverId: alertState?.driverId,
      coachingSessionId: alertState?.coachingSessionId,
    });
  }, []);

  const { data, error, loading, fetchData } = useAxios<any>(
    API_ENDPOINTS.alarm.VEHICLE_ALERT_COMMENT,
    'POST',
  );
  const { data: alertsEmailData, fetchData: fetchAlertsEmailData } = useAxios<any>(
    `${API_ENDPOINTS.alarm.SHARE_ALERT_DETAILS_EMAIL}`,
    'POST',
  );
  const {
    data: DriverCoachingVideosProgress,
    error: DriverCoachingVideosProgressError,
    loading: DriverCoachingVideosProgressLoading,
    fetchData: DriverCoachingVideosProgressData,
  } = useAxios<any>(API_ENDPOINTS.coaching.DRIVER_COACHINGPROGRESS_SAVE, 'POST');

  // useEffect(() => {
  //     DriverCoachingVideosProgressData({
  //         driverId: alertState?.driverId,
  //         coachingSessionId: alertState?.coachingSessionId,
  //         videoWatched: 0,
  //         totalVideoTime: 0,
  //         alertDate: "",
  //         videoName: ""
  //     })
  // }, [alertState]);
  const [selected, setSelected] = useState(2);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [email, setEmail] = useState('');
  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [userEmailValid, setUserEmailValid] = useState(false);
  useEffect(() => {
    setUserEmailValid(validateEmail(email));
  }, [email]);
  // Open the LiveFeedModal and process the videoUrl for the clicked alert

  const [videoDuration, setVideoDuration] = useState<number>(0);
  const [playedTime, setPlayedTime] = useState<number>(0);

  useEffect(() => {
    if (liveFeedCameraInfo.length > 0) {
      const video = document.createElement('video');
      video.src = liveFeedCameraInfo[0].playBackUrl;
      video.preload = 'metadata';
      video.muted = true; // allow autoplay
      video.crossOrigin = 'anonymous'; // helpful if from another origin

      let durationCaptured = false;

      const onLoadedMetadata = () => {
        setVideoDuration(video.duration);

        // Autoplay silently just to trigger timeupdate
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.warn('Autoplay failed:', error);
          });
        }
      };

      const onTimeUpdate = () => {
        setPlayedTime(video.currentTime);
      };

      video.addEventListener('loadedmetadata', onLoadedMetadata);
      video.addEventListener('timeupdate', onTimeUpdate);

      return () => {
        video.removeEventListener('loadedmetadata', onLoadedMetadata);
        video.removeEventListener('timeupdate', onTimeUpdate);
        video.pause();
        video.src = ''; // release memory
      };
    }
  }, [liveFeedCameraInfo]);

  const convertSecondsToHHMMSSNumber = (seconds: number): number => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    return parseInt(
      `${hrs.toString().padStart(2, '0')}${mins.toString().padStart(2, '0')}${secs
        .toString()
        .padStart(2, '0')}`,
    );
  };

  const handleOpenLiveFeed = (vehicleId: string, videoUrl: string[], alert: any) => {
    setIsLiveFeedOpen({ isOpen: true, tripId: vehicleId, vehicleId: vehicleId });
    const cameraInfo = videoUrl.map((url) => {
      const fileName = url.split('/').pop()?.split('?')[0] || '';
      const segments = fileName.split('_');
      const cameraCode = segments[1] || 'Unknown';
      const cameraMapping: Record<string, string> = {
        '01': 'FCW',
        '02': 'DSM',
        '03': 'REAR_CAMERA',
        '04': 'IN_CABIN',
      };
      const cameraId = cameraMapping[cameraCode] || 'Unknown';
      return {
        cameraId,
        cameraName: cameraId,
        playBackUrl: url,
        alertData: alert,
      };
    });
    setLiveFeedCameraInfo(cameraInfo);
    setSelected(0);
  };
  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({ isOpen: false, tripId: '', vehicleId: '' });
    setSelected(2);
    DriverCoachingVideosProgressData({
      driverId: alertState?.driverId,
      coachingSessionId: alertState?.coachingSessionId,
      videoWatched: convertSecondsToHHMMSSNumber(playedTime),
      totalVideoTime: convertSecondsToHHMMSSNumber(videoDuration),
      alertDate: liveFeedCameraInfo[0]?.alertData?.alertDate,
      videoName: liveFeedCameraInfo[0]?.playBackUrl,
    });
  };
  // const viewMenuData = [
  //     { name: 'View Details', icon: eye, click: () => navigate('/alarm/vehicle-alert-details', { state: alert }) },
  //     { name: 'Driver History', icon: call, click: () => { redirectToDriverHistory() } },
  //     { name: 'Trip Reconstruction', icon: reverse, click: () => { } },
  //     { name: 'Share Alert', icon: share, click: () => { setOpenEmailModal(true); setAnchorEl(null); } },
  // ];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [alert, setSelectedAlert] = useState<Alert | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const [alertComment, setAlertComment] = useState<string>('');
  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, alert: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedAlert(alert);
  };
  const redirectToDriverHistory = () => {
    console.log('alert', alert);
    if (!alert?.driverId || alert?.driverId === 'NA') {
      setDriverDialogOpen(true);
      return;
    } else {
      navigate(`/directories/drivers/${alert?.driverId}`);
    }
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  // const handleCommentModalOpen = (alert: any) => {
  //     setSelectedAlert(alert);
  //     console.log('alert', alert);
  //     if (alert?.comment) {
  //         setAlertComment(alert?.comment);
  //     }
  //     setModalOpen(true);
  // }
  const formatTimestamp = (timestamp: string) => {
    // Fix the format: replace ":" with space after the date
    const fixedTimestamp = timestamp.replace(':', 'T');

    // Parse with dayjs
    const parsedDate = dayjs(fixedTimestamp);

    // Format it
    return parsedDate.format('DD MMMM YYYY, hh:mm A'); // e.g., "01 June 2025, 08:56 AM"
  };

  const saveComment = () => {
    fetchData({
      deviceId: alert?.device_id,
      comment: alertComment,
      sortKey: alert?.warningSortKey,
    });
    setModalOpen(false);
  };
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);
  const handleEmailClose = () => {
    setEmail('');
    setOpenEmailModal(false);
  };
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);
  useEffect(() => {
    if (alertsEmailData) {
      if (alertsEmailData.status === 200) {
        setAlertMessage('Email sent successfully');
        setAlertType('success');
        setAlertOpen(true);
      } else {
        setAlertMessage('Failed to send email');
        setAlertType('error');
        setAlertOpen(true);
      }
    }
  }, [alertsEmailData]);
  const handleSubmit = () => {
    if (!userEmailValid) {
      setAlertMessage('Please enter a valid email address');
      return;
    }
    console.log('Sharing Footage link:', window.location.href, 'with email:', email);
    console.log('alert', alert);
    fetchAlertsEmailData({
      emailId: email,
      deviceId: alert?.device_id,
      warningSortKey: alert?.warningSortKey,
    });
    setEmail('');
    setOpenEmailModal(false);
  };
  const handleEmailModalOpen = () => {
    setOpenEmailModal(true);
  };
  const driverDialogClose = () => {
    setDriverDialogOpen(false);
  };
  return (
    <Box className="grid grid-cols-4 gap-3">
      {DriverCoachingVideosData &&
        DriverCoachingVideosData?.data.map(
          (
            alert: { vehicleId: string; videoUrl: string[]; alertDate: string },
            index: React.Key | null | undefined,
          ) => (
            <Card
              key={index}
              sx={{
                maxWidth: 375.5,
                height: 85,
                borderRadius: '12px',
                border: '1px solid #F0EFF8',
                boxShadow: 'none',
                '&:hover': { boxShadow: 3 },
              }}
              className="transition-shadow"
            >
              <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    width: '100%',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                      {alert.vehicleId || 'NA'}
                    </Typography>
                    {/* <img
                                    src={comment}
                                    alt="comment"
                                    style={{ width: 20, height: 20, cursor: 'pointer' }}
                                    onClick={() => handleCommentModalOpen(alert)}
                                /> */}
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <IconButton
                      size="small"
                      sx={{ color: '#5547DD', p: 0 }}
                      onClick={() => handleOpenLiveFeed(alert.vehicleId, alert.videoUrl, alert)}
                    >
                      <PlayArrow fontSize="medium" />
                    </IconButton>
                    {/* <IconButton
                                    size="small"
                                    onClick={(event) => handleOpenMenu(event, alert)}
                                    sx={{ p: 0 }}
                                >
                                    <MoreVert fontSize="small" />
                                </IconButton> */}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  {/* <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                {alert.vehicleId}
                            </Typography> */}
                  <Typography variant="caption" sx={dateTimeStyles}>
                    {formatTimestamp(alert?.alertDate)}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ),
        )}
      {/* <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
            >
                {viewMenuData.map((item, index) => (
                    <MenuItem key={index} onClick={item.click}>
                        <div className="flex gap-2 mt-1">
                            <img src={item.icon} alt={item.name} style={{ marginRight: 8, width: 20, height: 20 }} />
                            <Typography variant="body2" fontWeight={600}>
                                {item.name}
                            </Typography>
                        </div>
                    </MenuItem>
                ))}
            </Menu> */}
      {/* <Modal
                open={modalOpen}
                onClose={handleClose}
                aria-labelledby="add-comment-modal"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Box
                    sx={{
                        width: 560,
                        height: 472,
                        p: 4,
                        borderRadius: '16px',
                        border: '1px solid #F0EFF8',
                        backgroundColor: 'background.paper',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            fontFamily: 'Inter Tight',
                            fontWeight: 600,
                            fontSize: '24px',
                            lineHeight: '36px'
                        }}
                    >
                        Add Comment
                    </Typography>
                    
                    <Typography
                        sx={{
                            fontFamily: 'Inter Tight',
                            fontWeight: 400,
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: 'text.secondary'
                        }}
                    >
                        Provide additional context or recommendations for this alert. Your comments will be logged for future reference and analysis.
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography
                            sx={{
                                fontFamily: 'Inter Tight',
                                fontWeight: 'bold',
                                fontSize: '16px',
                                lineHeight: '24px',
                                color: 'text.primary'
                            }}
                        >
                            Comments
                        </Typography>
                        <TextField
                            label="Write here"
                            multiline
                            rows={4}
                            value={alertComment}
                            onChange={(e) => setAlertComment(e.target.value)}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                sx: {
                                    fontFamily: 'Inter Tight',
                                    fontWeight: 400
                                }
                            }}
                            InputProps={{
                                sx: {
                                    fontFamily: 'Inter Tight',
                                    fontWeight: 400
                                }
                            }}
                        />
                    </Box>
                    
                    <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            sx={{
                                fontFamily: 'Inter Tight',
                                fontWeight: 500,
                                textTransform: 'none'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => saveComment()}
                            sx={{
                                fontFamily: 'Inter Tight',
                                fontWeight: 500,
                                textTransform: 'none',
                                ml: 'auto'
                            }}
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Modal> */}
      <Modal open={openEmailModal} onClose={handleEmailClose}>
        <Box
          sx={{
            position: 'absolute' as const,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: 500 },
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Typography variant="h6">{heading}</Typography>
            <CustomIconButton
              text={`Copy Link`}
              icon={<img src={link} alt="link" width={24} height={24} />}
              background="transparent"
              outline={false}
              padding="0px"
              size={16}
              variant="outlined"
              onClick={() => {
                navigator.clipboard
                  .writeText(window.location.href)
                  .then(() => {
                    console.log('Link copied to clipboard!');
                  })
                  .catch((err) => {
                    console.error('Failed to copy link: ', err);
                  });
              }}
            />
          </Box>
          <Typography variant="button" fontWeight={400} className="mb-1" color="secondary">
            {subheading}
          </Typography>
          <div className="mt-4">
            <InputField
              label="Email Address"
              name="email"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
              placeholder="Enter email address"
              status={email.length === 0 ? undefined : userEmailValid ? 'success' : 'error'}
              isDisabled={false}
            />
          </div>
          <div className="flex w-full mt-8 justify-between">
            <CustomIconButton
              text={`Cancel`}
              background="transparent"
              outline={true}
              padding="0px"
              size={16}
              variant="outlined"
              onClick={handleEmailClose}
            />
            <CustomIconButton
              text={`Send`}
              padding="0px"
              outline={false}
              size={16}
              isDisabled={!userEmailValid}
              variant="contained"
              onClick={handleSubmit}
            />
          </div>
        </Box>
      </Modal>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <LiveFeedModal
        type="alert"
        alertName="Alert Evidence Video"
        selectedCamera={selected}
        trip={isLiveFeedOpen}
        cameraInfo={liveFeedCameraInfo}
        isDash={true}
        open={isLiveFeedOpen.isOpen}
        onClose={handleLiveFeedClose}
        isDriverCoachingVideos={true}
      />
      <Dialog
        open={driverDialogOpen}
        onClose={driverDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Driver not associated with this particular alert
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={driverDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AlertsGrid;
